import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function RobotsMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement("meta"); m.name = "robots"; document.head.appendChild(m); }
    m.content = pathname === "/" ? "index, follow" : "noindex, nofollow";
  }, [pathname]);
  return null;
}
